<template>

<form
  class="mx-auto col-sm-8"
  @submit.prevent
>
  <div class="form-group" :class="{ 'has-error': errors.has('name') }">
    <label for="name">{{ $t('name') }}</label>
    <input
      type="text"
      id="name"
      name="name"
      class="form-control"
      :placeholder="$t('type_name')"
      v-model="permission.name"
      v-validate="'required'"
    >
    <small v-show="errors.has('name')" class="form-text text-muted">
      {{ errors.first('name') }}
    </small>
  </div>

  <div class="form-group" :class="{ 'has-error': errors.has('tag') }">
    <label for="tag">{{ $t('tag') }}</label>
    <input
      type="text"
      id="tag"
      name="tag"
      class="form-control"
      :placeholder="$t('type_tag')"
      v-model="permission.tag"
      v-validate="'required'"
    >
    <small v-show="errors.has('tag')" class="form-text text-muted">
      {{ errors.first('tag') }}
    </small>
  </div>

  <div class="form-group form-check">
    <input
      type="checkbox"
      class="form-check-input"
      id="active"
      v-model="permission.isPublic"
    >
    <label class="form-check-label" for="active">{{ $t('public') }}</label>
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton
        @click="save"
        :loading="isLoading"
      >
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div>
</form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'

export default {
  name: 'PermissionForm',
  components: {
    LoaderButton
  },
  props: {
    permission: {
      type: Object,
      default: () => ({
        id: undefined,
        name: '',
        tag: '',
        isPublic: true
      })
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.permission.isLoading
    })
  },
  methods: {
    ...mapActions('permission', [
      'create',
      'edit',
      'cleanState'
    ]),

    async save (evt, done) {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }
      const { id, name, tag, isPublic } = this.permission
      const requestData = { name, tag, isPublic }
      let promiseSave
      if (id) {
        promiseSave = this.edit({ id, data: requestData })
      } else {
        promiseSave = this.create(requestData)
      }
      const result = await promiseSave
      if (result) {
        this.$router.push({ name: 'listpermission' })
      }
    }
  },
  destroyed () {
    this.cleanState()
  }
}
</script>
